var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKuroMini(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 131.367,
    height: 146.009,
    viewBox: "0 0 131.367 146.009",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill-rule: evenodd;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_639",
    "data-name": "Group 639",
    transform: "translate(-111.639 -833)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2025",
    "data-name": "Path 2025",
    className: "cls-1",
    d: "M88.171,8.057c2.795-1.613,37.706-9.092,39.568-7.936S32.35,131.458,28.714,134.838.4,142.368,0,140.6,85.387,9.677,88.171,8.057",
    transform: "translate(111.638 832.999)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2026",
    "data-name": "Path 2026",
    className: "cls-1",
    d: "M30.43,77.486c-1.083-2.932,16.183-25.174,16.183-25.174S66.755,25.749,69.38,24.321s16.191,1.186,15.76,3.644S57.152,64.373,61.556,72.993s40.357,43.572,39.819,44.348-29.105-4.2-30.864-5.261-39-31.655-40.08-34.594",
    transform: "translate(141.625 861.585)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKuroMini);
export default __webpack_public_path__ + "static/media/kuroMini.3d88bad821569dd4fdf2535d089859bb.svg";
export { ForwardRef as ReactComponent };